<template>
  <v-btn icon :aria-label="$t('contactMessengerFab')" :color="MESSENGER_COLOR" position="fixed" size="large"
    elevation="8"
    :style="{ right: '16px', bottom: `calc(env(safe-area-inset-bottom, 0px) + ${bottomOffset}px)`, zIndex: 1004 }"
    @click="openExternal(MESSENGER_URL)">
    <v-badge offset-x="-10" dot color="success"><v-icon size="35" :icon="mdiFacebookMessenger" /></v-badge>
    <v-tooltip activator="parent" location="start" :text="$t('contactMessengerFab')" />
  </v-btn>
</template>

<script setup>
import { mdiFacebookMessenger } from '@mdi/js';
import { MESSENGER_URL, MESSENGER_COLOR } from '@/constants/contact';
import { openExternal } from '@/utils/openExternal';

defineProps({
  bottomOffset: { type: Number, default: 20 },
});
</script>
